const professionalExperience = [
  { 
    companyIcon: 'virtual_planet.png', 
    role: 'Programador Unity', 
    companyName: 'Virtual Planet Technologies LLC ', 
    companyLocation: 'California, Estados Unidos', 
    year: 'Agosto 2023 - Presente'
  },
  { 
    companyIcon: 'ludus_studios.png', 
    role: 'Programador Unity', 
    companyName: 'Ludus Studios ', 
    companyLocation: 'Pará, Brasil', 
    year: 'Março 2023 - Maio 2023'
  },
  { 
    companyIcon: 'brais_games.png', 
    role: 'Desenvolvedor de Jogos Unity', 
    companyName: 'Brais Games ', 
    companyLocation: 'Paraíba, Brasil', 
    year: 'Fevereiro 2021 - Fevereiro 2023'
  },
];
export default professionalExperience;